import { z } from 'zod';

/**
 * URL state of the health console — refresh and share-a-link land on the same
 * view. `problems` = failing + needs attention, the default a governance
 * reviewer wants.
 */
export const healthConsoleStateSchema = z.enum([
  'problems',
  'all',
  'failing',
  'attention',
  'checking',
  'healthy',
]);
export type HealthConsoleState = z.infer<typeof healthConsoleStateSchema>;

export const healthConsoleSearchSchema = z.object({
  state: healthConsoleStateSchema.optional(),
  q: z.string().trim().max(100).optional(),
  area: z.string().trim().max(80).optional(),
});
export type HealthConsoleSearch = z.infer<typeof healthConsoleSearchSchema>;
